// // // // // // // // // // import React, { useState } from 'react';
// // // // // // // // // // import { Link } from 'react-router-dom';
// // // // // // // // // // import { useUser } from '../UserContext';
// // // // // // // // // // import { FaBell } from 'react-icons/fa';
// // // // // // // // // // import { useNotifications } from './NotificationSetup'; // ← import the hook
// // // // // // // // // // import NotificationsList from './NotificationsList';       // ← import the list component

// // // // // // // // // // const Navbar = () => {
// // // // // // // // // //   const { user } = useUser();

// // // // // // // // // //   return (
// // // // // // // // // //     <div className="w-full bg-gradient-hero">
// // // // // // // // // //       <div className="container mx-auto flex items-center justify-between py-4 px-1">
// // // // // // // // // //         <img
// // // // // // // // // //           src="/images/logo2.png"
// // // // // // // // // //           alt="ONE Simulation"
// // // // // // // // // //           className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
// // // // // // // // // //           draggable="false"
// // // // // // // // // //         />

// // // // // // // // // //         <div className="flex items-center space-x-4">
// // // // // // // // // //           {!user ? (
// // // // // // // // // //             <>
// // // // // // // // // //               <Link to="/login">
// // // // // // // // // //                 <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
// // // // // // // // // //                   Login
// // // // // // // // // //                 </button>
// // // // // // // // // //               </Link>
// // // // // // // // // //               <Link to="/signup">
// // // // // // // // // //                 <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
// // // // // // // // // //                   Signup
// // // // // // // // // //                 </button>
// // // // // // // // // //               </Link>
// // // // // // // // // //             </>
// // // // // // // // // //           ) : (
// // // // // // // // // //             <NavbarNotifications />
// // // // // // // // // //           )}
// // // // // // // // // //         </div>
// // // // // // // // // //       </div>
// // // // // // // // // //     </div>
// // // // // // // // // //   );
// // // // // // // // // // };

// // // // // // // // // // function NavbarNotifications() {
// // // // // // // // // //   const [open, setOpen] = useState(false);

// // // // // // // // // //   // Pull notifications array from context
// // // // // // // // // //   const notifications = useNotifications();

// // // // // // // // // //   // Compute actual unread count (notifications with isRead === false)
// // // // // // // // // //   const unreadCount = notifications.filter((n) => !n.isRead).length;

// // // // // // // // // //   return (
// // // // // // // // // //     <div className="relative">
// // // // // // // // // //       <button
// // // // // // // // // //         className="relative focus:outline-none"
// // // // // // // // // //         onClick={() => setOpen((o) => !o)}
// // // // // // // // // //         aria-label="Show notifications"
// // // // // // // // // //       >
// // // // // // // // // //         <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
// // // // // // // // // //         {unreadCount > 0 && (
// // // // // // // // // //           <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
// // // // // // // // // //         )}
// // // // // // // // // //       </button>

// // // // // // // // // //       {open && (
// // // // // // // // // //         <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
// // // // // // // // // //           <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
// // // // // // // // // //             Notifications
// // // // // // // // // //             {unreadCount > 0 && (
// // // // // // // // // //               <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
// // // // // // // // // //                 {unreadCount} new
// // // // // // // // // //               </span>
// // // // // // // // // //             )}
// // // // // // // // // //           </div>
// // // // // // // // // //           <div className="max-h-72 overflow-y-auto">
// // // // // // // // // //             {/* Render the NotificationsList component (handles "no notifications" and marking as read) */}
// // // // // // // // // //             <NotificationsList />
// // // // // // // // // //           </div>
// // // // // // // // // //         </div>
// // // // // // // // // //       )}
// // // // // // // // // //     </div>
// // // // // // // // // //   );
// // // // // // // // // // }

// // // // // // // // // // export default Navbar;



// // // // // // // // // import React, { useState } from 'react';
// // // // // // // // // import { Link } from 'react-router-dom';
// // // // // // // // // import { useUser } from '../UserContext';
// // // // // // // // // import { FaBell } from 'react-icons/fa';
// // // // // // // // // import { useNotifications } from './NotificationSetup';
// // // // // // // // // import NotificationsList from './NotificationsList';

// // // // // // // // // const Navbar = () => {
// // // // // // // // //   const { user } = useUser();

// // // // // // // // //   return (
// // // // // // // // //     <div className="w-full bg-gradient-hero">
// // // // // // // // //       <div className="container mx-auto flex items-center justify-between py-4 px-1">
// // // // // // // // //         <img
// // // // // // // // //           src="/images/logo2.png"
// // // // // // // // //           alt="ONE Simulation"
// // // // // // // // //           className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
// // // // // // // // //           draggable="false"
// // // // // // // // //         />

// // // // // // // // //         <div className="flex items-center space-x-4">
// // // // // // // // //           {!user ? (
// // // // // // // // //             <>
// // // // // // // // //               <Link to="/login">
// // // // // // // // //                 <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
// // // // // // // // //                   Login
// // // // // // // // //                 </button>
// // // // // // // // //               </Link>
// // // // // // // // //               <Link to="/signup">
// // // // // // // // //                 <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
// // // // // // // // //                   Signup
// // // // // // // // //                 </button>
// // // // // // // // //               </Link>
// // // // // // // // //             </>
// // // // // // // // //           ) : (
// // // // // // // // //             <NavbarNotifications />
// // // // // // // // //           )}
// // // // // // // // //         </div>
// // // // // // // // //       </div>
// // // // // // // // //     </div>
// // // // // // // // //   );
// // // // // // // // // };

// // // // // // // // // function NavbarNotifications() {
// // // // // // // // //   // Destructure so that `notifications` is the actual array
// // // // // // // // //   const { notifications, setNotifications } = useNotifications();
// // // // // // // // //   const [open, setOpen] = useState(false);

// // // // // // // // //   // Compute unread count from the array
// // // // // // // // //   const unreadCount = notifications.filter((n) => !n.isRead).length;

// // // // // // // // //   return (
// // // // // // // // //     <div className="relative">
// // // // // // // // //       <button
// // // // // // // // //         className="relative focus:outline-none"
// // // // // // // // //         onClick={() => setOpen((o) => !o)}
// // // // // // // // //         aria-label="Show notifications"
// // // // // // // // //       >
// // // // // // // // //         <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
// // // // // // // // //         {unreadCount > 0 && (
// // // // // // // // //           <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
// // // // // // // // //         )}
// // // // // // // // //       </button>

// // // // // // // // //       {open && (
// // // // // // // // //         <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
// // // // // // // // //           <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
// // // // // // // // //             Notifications
// // // // // // // // //             {unreadCount > 0 && (
// // // // // // // // //               <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
// // // // // // // // //                 {unreadCount} new
// // // // // // // // //               </span>
// // // // // // // // //             )}
// // // // // // // // //           </div>
// // // // // // // // //           <div className="max-h-72 overflow-y-auto">
// // // // // // // // //             {/* Pass both notifications array & setter to the list */}
// // // // // // // // //             <NotificationsList
// // // // // // // // //               notifications={notifications}
// // // // // // // // //               setNotifications={setNotifications}
// // // // // // // // //             />
// // // // // // // // //           </div>
// // // // // // // // //         </div>
// // // // // // // // //       )}
// // // // // // // // //     </div>
// // // // // // // // //   );
// // // // // // // // // }

// // // // // // // // // export default Navbar;



// // // // // // // // import React, { useState } from 'react';
// // // // // // // // import { useNotifications } from './NotificationSetup';
// // // // // // // // import NotificationsList from './NotificationsList';
// // // // // // // // import { FaBell } from 'react-icons/fa';

// // // // // // // // function NavbarNotifications() {
// // // // // // // //   const { notifications, setNotifications } = useNotifications();
// // // // // // // //   const [open, setOpen] = useState(false);

// // // // // // // //   // Compute unread count from the actual array
// // // // // // // //   const unreadCount = notifications.filter((n) => !n.isRead).length;

// // // // // // // //   return (
// // // // // // // //     <div className="relative">
// // // // // // // //       <button
// // // // // // // //         onClick={() => setOpen((o) => !o)}
// // // // // // // //         aria-label="Show notifications"
// // // // // // // //       >
// // // // // // // //         <FaBell />
// // // // // // // //         {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
// // // // // // // //       </button>

// // // // // // // //       {open && (
// // // // // // // //         <div className="notification-dropdown">
// // // // // // // //           <div className="header">
// // // // // // // //             Notifications
// // // // // // // //             {unreadCount > 0 && <span className="new-badge">{unreadCount} new</span>}
// // // // // // // //           </div>
// // // // // // // //           <div className="list-container">
// // // // // // // //             {/* Pass both notifications & setter down */}
// // // // // // // //             <NotificationsList
// // // // // // // //               notifications={notifications}
// // // // // // // //               setNotifications={setNotifications}
// // // // // // // //             />
// // // // // // // //           </div>
// // // // // // // //         </div>
// // // // // // // //       )}
// // // // // // // //     </div>
// // // // // // // //   );
// // // // // // // // }


// // // // // // // // export default Navbar;


// // // // // // // import React, { useState } from 'react';
// // // // // // // import { Link } from 'react-router-dom';
// // // // // // // import { useUser } from '../UserContext';
// // // // // // // import { FaBell } from 'react-icons/fa';
// // // // // // // import { useNotifications } from './NotificationSetup';
// // // // // // // import NotificationsList from './NotificationsList';

// // // // // // // const Navbar = () => {
// // // // // // //   const { user } = useUser();

// // // // // // //   return (
// // // // // // //     <div className="w-full bg-gradient-hero">
// // // // // // //       <div className="container mx-auto flex items-center justify-between py-4 px-1">
// // // // // // //         <img
// // // // // // //           src="/images/logo2.png"
// // // // // // //           alt="ONE Simulation"
// // // // // // //           className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
// // // // // // //           draggable="false"
// // // // // // //         />

// // // // // // //         <div className="flex items-center space-x-4">
// // // // // // //           {!user ? (
// // // // // // //             <>
// // // // // // //               <Link to="/login">
// // // // // // //                 <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
// // // // // // //                   Login
// // // // // // //                 </button>
// // // // // // //               </Link>
// // // // // // //               <Link to="/signup">
// // // // // // //                 <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
// // // // // // //                   Signup
// // // // // // //                 </button>
// // // // // // //               </Link>
// // // // // // //             </>
// // // // // // //           ) : (
// // // // // // //             <NavbarNotifications />
// // // // // // //           )}
// // // // // // //         </div>
// // // // // // //       </div>
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // };

// // // // // // // function NavbarNotifications() {
// // // // // // //   // Destructure so that `notifications` is the actual array
// // // // // // //   const { notifications, setNotifications } = useNotifications();
// // // // // // //   const [open, setOpen] = useState(false);

// // // // // // //   // Compute unread count from the array
// // // // // // //   const unreadCount = notifications.filter((n) => !n.isRead).length;

// // // // // // //   return (
// // // // // // //     <div className="relative">
// // // // // // //       <button
// // // // // // //         className="relative focus:outline-none"
// // // // // // //         onClick={() => setOpen((o) => !o)}
// // // // // // //         aria-label="Show notifications"
// // // // // // //       >
// // // // // // //         <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
// // // // // // //         {unreadCount > 0 && (
// // // // // // //           <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
// // // // // // //         )}
// // // // // // //       </button>

// // // // // // //       {open && (
// // // // // // //         <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
// // // // // // //           <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
// // // // // // //             Notifications
// // // // // // //             {unreadCount > 0 && (
// // // // // // //               <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
// // // // // // //                 {unreadCount} new
// // // // // // //               </span>
// // // // // // //             )}
// // // // // // //           </div>
// // // // // // //           <div className="max-h-72 overflow-y-auto">
// // // // // // //             {/* Pass both notifications array & setter to the list */}
// // // // // // //             <NotificationsList
// // // // // // //               notifications={notifications}
// // // // // // //               setNotifications={setNotifications}
// // // // // // //             />
// // // // // // //           </div>
// // // // // // //         </div>
// // // // // // //       )}
// // // // // // //     </div>
// // // // // // //   );
// // // // // // // }

// // // // // // // export default Navbar;

// // // // // // import React, { useState } from 'react';
// // // // // // import { useNotifications } from '../NotificationSetup';
// // // // // // import NotificationsList from './NotificationsList';
// // // // // // import { FaBell } from 'react-icons/fa';

// // // // // // function NavbarNotifications() {
// // // // // //   const { notifications, setNotifications } = useNotifications();
// // // // // //   const [open, setOpen] = useState(false);

// // // // // //   // Compute unread count from the actual array
// // // // // //   const unreadCount = notifications.filter((n) => !n.isRead).length;

// // // // // //   return (
// // // // // //     <div className="relative">
// // // // // //       <button
// // // // // //         onClick={() => setOpen((o) => !o)}
// // // // // //         aria-label="Show notifications"
// // // // // //       >
// // // // // //         <FaBell />
// // // // // //         {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
// // // // // //       </button>

// // // // // //       {open && (
// // // // // //         <div className="notification-dropdown">
// // // // // //           <div className="header">
// // // // // //             Notifications
// // // // // //             {unreadCount > 0 && <span className="new-badge">{unreadCount} new</span>}
// // // // // //           </div>
// // // // // //           <div className="list-container">
// // // // // //             {/* Pass both notifications & setter down */}
// // // // // //             <NotificationsList
// // // // // //               notifications={notifications}
// // // // // //               setNotifications={setNotifications}
// // // // // //             />
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       )}
// // // // // //     </div>
// // // // // //   );
// // // // // // }
// // // // // // src/Components/Navbar.js

// // // // // import React, { useState } from 'react';
// // // // // import { Link } from 'react-router-dom';
// // // // // import { FaBell } from 'react-icons/fa';
// // // // // import { useNotifications } from './NotificationSetup'; // <-- adjust path if needed
// // // // // import NotificationsList from './NotificationsList';      // <-- adjust path if needed

// // // // // const Navbar = () => {
// // // // //   const { user } = useUser(); // Assuming you have a UserContext

// // // // //   return (
// // // // //     <div className="w-full bg-gradient-hero">
// // // // //       <div className="container mx-auto flex items-center justify-between py-4 px-1">
// // // // //         <img
// // // // //           src="/images/logo2.png"
// // // // //           alt="ONE Simulation"
// // // // //           className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
// // // // //           draggable="false"
// // // // //         />

// // // // //         <div className="flex items-center space-x-4">
// // // // //           {!user ? (
// // // // //             <>
// // // // //               <Link to="/login">
// // // // //                 <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
// // // // //                   Login
// // // // //                 </button>
// // // // //               </Link>
// // // // //               <Link to="/signup">
// // // // //                 <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
// // // // //                   Signup
// // // // //                 </button>
// // // // //               </Link>
// // // // //             </>
// // // // //           ) : (
// // // // //             <NavbarNotifications />
// // // // //           )}
// // // // //         </div>
// // // // //       </div>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // function NavbarNotifications() {
// // // // //   // 1) Destructure the object returned by useNotifications()
// // // // //   const { notifications, setNotifications } = useNotifications();
// // // // //   const [open, setOpen] = useState(false);

// // // // //   // 2) Compute unread count from the array
// // // // //   const unreadCount = notifications.filter((n) => !n.isRead).length;

// // // // //   return (
// // // // //     <div className="relative">
// // // // //       <button
// // // // //         className="relative focus:outline-none"
// // // // //         onClick={() => setOpen((o) => !o)}
// // // // //         aria-label="Show notifications"
// // // // //       >
// // // // //         <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
// // // // //         {unreadCount > 0 && (
// // // // //           <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
// // // // //         )}
// // // // //       </button>

// // // // //       {open && (
// // // // //         <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
// // // // //           <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
// // // // //             Notifications
// // // // //             {unreadCount > 0 && (
// // // // //               <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
// // // // //                 {unreadCount} new
// // // // //               </span>
// // // // //             )}
// // // // //           </div>
// // // // //           <div className="max-h-72 overflow-y-auto">
// // // // //             {/* Pass both notifications and setNotifications down to the list */}
// // // // //             <NotificationsList
// // // // //               notifications={notifications}
// // // // //               setNotifications={setNotifications}
// // // // //             />
// // // // //           </div>
// // // // //         </div>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // }

// // // // // // Make sure to import useUser if you haven't
// // // // // import { useUser } from '../UserContext'; // <-- adjust path if needed

// // // // // export default Navbar;



// // // // // src/Components/Navbar.js

// // // // import React, { useState } from 'react';
// // // // import { Link } from 'react-router-dom';
// // // // import { FaBell } from 'react-icons/fa';
// // // // import { useUser } from '../UserContext';            // ← must be at top
// // // // import { useNotifications } from './NotificationSetup'; // ← must be at top
// // // // import NotificationsList from './NotificationsList';      // ← must be at top

// // // // const Navbar = () => {
// // // //   const { user } = useUser();

// // // //   return (
// // // //     <div className="w-full bg-gradient-hero">
// // // //       <div className="container mx-auto flex items-center justify-between py-4 px-1">
// // // //         <img
// // // //           src="/images/logo2.png"
// // // //           alt="ONE Simulation"
// // // //           className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
// // // //           draggable="false"
// // // //         />

// // // //         <div className="flex items-center space-x-4">
// // // //           {!user ? (
// // // //             <>
// // // //               <Link to="/login">
// // // //                 <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
// // // //                   Login
// // // //                 </button>
// // // //               </Link>
// // // //               <Link to="/signup">
// // // //                 <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
// // // //                   Signup
// // // //                 </button>
// // // //               </Link>
// // // //             </>
// // // //           ) : (
// // // //             <NavbarNotifications />
// // // //           )}
// // // //         </div>
// // // //       </div>
// // // //     </div>
// // // //   );
// // // // };

// // // // function NavbarNotifications() {
// // // //   const { notifications, setNotifications } = useNotifications();
// // // //   const [open, setOpen] = useState(false);

// // // //   // Compute the number of unread notifications
// // // //   const unreadCount = notifications.filter((n) => !n.isRead).length;

// // // //   return (
// // // //     <div className="relative">
// // // //       <button
// // // //         className="relative focus:outline-none"
// // // //         onClick={() => setOpen((o) => !o)}
// // // //         aria-label="Show notifications"
// // // //       >
// // // //         <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
// // // //         {unreadCount > 0 && (
// // // //           <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
// // // //         )}
// // // //       </button>

// // // //       {open && (
// // // //         <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
// // // //           <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
// // // //             Notifications
// // // //             {unreadCount > 0 && (
// // // //               <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
// // // //                 {unreadCount} new
// // // //               </span>
// // // //             )}
// // // //           </div>
// // // //           <div className="max-h-72 overflow-y-auto">
// // // //             <NotificationsList
// // // //               notifications={notifications}
// // // //               setNotifications={setNotifications}
// // // //             />
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </div>
// // // //   );
// // // // }

// // // // export default Navbar;


// // // // src/Components/Navbar.js

// // // import React, { useState } from 'react';
// // // import { Link } from 'react-router-dom';
// // // import { FaBell } from 'react-icons/fa';
// // // import { useUser } from '../UserContext';
// // // import { useNotifications } from '../NotificationSetup';
// // // import NotificationsList from './NotificationsList';

// // // const Navbar = () => {
// // //   const { user } = useUser();

// // //   return (
// // //     <div className="w-full bg-gradient-hero">
// // //       <div className="container mx-auto flex items-center justify-between py-4 px-1">
// // //         <img
// // //           src="/images/logo2.png"
// // //           alt="ONE Simulation"
// // //           className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
// // //           draggable="false"
// // //         />

// // //         <div className="flex items-center space-x-4">
// // //           {!user ? (
// // //             <>
// // //               <Link to="/login">
// // //                 <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
// // //                   Login
// // //                 </button>
// // //               </Link>
// // //               <Link to="/signup">
// // //                 <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
// // //                   Signup
// // //                 </button>
// // //               </Link>
// // //             </>
// // //           ) : (
// // //             <NavbarNotifications />
// // //           )}
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // function NavbarNotifications() {
// // //   // Destructure so notifications is the array
// // //   const { notifications, setNotifications } = useNotifications();
// // //   const [open, setOpen] = useState(false);

// // //   // Compute how many are still unread
// // //   const unreadCount = Array.isArray(notifications)
// // //     ? notifications.filter((n) => !n.isRead).length
// // //     : 0;

// // //   return (
// // //     <div className="relative">
// // //       <button
// // //         className="relative focus:outline-none"
// // //         onClick={() => setOpen((o) => !o)}
// // //         aria-label="Show notifications"
// // //       >
// // //         <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
// // //         {unreadCount > 0 && (
// // //           <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
// // //         )}
// // //       </button>

// // //       {open && (
// // //         <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
// // //           <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
// // //             Notifications
// // //             {unreadCount > 0 && (
// // //               <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
// // //                 {unreadCount} new
// // //               </span>
// // //             )}
// // //           </div>
// // //           <div className="max-h-72 overflow-y-auto">
// // //             <NotificationsList
// // //               notifications={notifications}
// // //               setNotifications={setNotifications}
// // //             />
// // //           </div>
// // //         </div>
// // //       )}
// // //     </div>
// // //   );
// // // }

// // // export default Navbar;

// // // src/Components/Navbar.js

// // import React, { useState } from 'react';
// // import { Link } from 'react-router-dom';
// // import { FaBell } from 'react-icons/fa';
// // import { useUser } from '../UserContext';             // ← adjust path if needed
// // import { useNotifications } from './NotificationSetup'; // ← adjust path if needed
// // import NotificationsList from './NotificationsList';      // ← adjust path if needed

// // const Navbar = () => {
// //   const { user } = useUser();

// //   return (
// //     <div className="w-full bg-gradient-hero">
// //       <div className="container mx-auto flex items-center justify-between py-4 px-1">
// //         <img
// //           src="/images/logo2.png"
// //           alt="ONE Simulation"
// //           className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
// //           draggable="false"
// //         />

// //         <div className="flex items-center space-x-4">
// //           {!user ? (
// //             <>
// //               <Link to="/login">
// //                 <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
// //                   Login
// //                 </button>
// //               </Link>
// //               <Link to="/signup">
// //                 <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
// //                   Signup
// //                 </button>
// //               </Link>
// //             </>
// //           ) : (
// //             <NavbarNotifications />
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // function NavbarNotifications() {
// //   // Destructure so notifications is an array
// //   const { notifications, setNotifications } = useNotifications();
// //   const [open, setOpen] = useState(false);

// //   // Only count those with isRead === false
// //   const unreadCount = Array.isArray(notifications)
// //     ? notifications.filter((n) => !n.isRead).length
// //     : 0;

// //   return (
// //     <div className="relative">
// //       <button
// //         className="relative focus:outline-none"
// //         onClick={() => setOpen((o) => !o)}
// //         aria-label="Show notifications"
// //       >
// //         <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
// //         {unreadCount > 0 && (
// //           <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
// //         )}
// //       </button>

// //       {open && (
// //         <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
// //           <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
// //             Notifications
// //             {unreadCount > 0 && (
// //               <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
// //                 {unreadCount} new
// //               </span>
// //             )}
// //           </div>
// //           <div className="max-h-72 overflow-y-auto">
// //             <NotificationsList
// //               notifications={notifications}
// //               setNotifications={setNotifications}
// //             />
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // }

// // export default Navbar;
// // src/Components/Navbar.js

// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { FaBell } from 'react-icons/fa';
// import { useUser } from '../UserContext';             // ← adjust path if needed
// import { useNotifications } from './NotificationSetup'; // ← adjust path if needed
// import NotificationsList from './NotificationsList';      // ← adjust path if needed

// const Navbar = () => {
//   const { user } = useUser();

//   return (
//     <div className="w-full bg-gradient-hero">
//       <div className="container mx-auto flex items-center justify-between py-4 px-1">
//         <img
//           src="/images/logo2.png"
//           alt="ONE Simulation"
//           className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
//           draggable="false"
//         />

//         <div className="flex items-center space-x-4">
//           {!user ? (
//             <>
//               <Link to="/login">
//                 <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
//                   Login
//                 </button>
//               </Link>
//               <Link to="/signup">
//                 <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
//                   Signup
//                 </button>
//               </Link>
//             </>
//           ) : (
//             <NavbarNotifications />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// function NavbarNotifications() {
//   // Destructure so notifications is an array
//   const { notifications, setNotifications } = useNotifications();
//   const [open, setOpen] = useState(false);

//   // Only count those with isRead === false
//   const unreadCount = Array.isArray(notifications)
//     ? notifications.filter((n) => !n.isRead).length
//     : 0;

//   return (
//     <div className="relative">
//       <button
//         className="relative focus:outline-none"
//         onClick={() => setOpen((o) => !o)}
//         aria-label="Show notifications"
//       >
//         <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
//         {unreadCount > 0 && (
//           <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
//         )}
//       </button>

//       {open && (
//         <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
//           <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
//             Notifications
//             {unreadCount > 0 && (
//               <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
//                 {unreadCount} new
//               </span>
//             )}
//           </div>
//           <div className="max-h-72 overflow-y-auto">
//             <NotificationsList
//               notifications={notifications}
//               setNotifications={setNotifications}
//             />
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Navbar;
// src/Components/Navbar.js

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBell } from 'react-icons/fa';
import { useUser } from '../UserContext';             // adjust path if needed
import { useNotifications } from './NotificationSetup'; // adjust path
import NotificationsList from './NotificationsList';      // adjust path

const Navbar = () => {
  const { user } = useUser();

  return (
    <div className="w-full bg-gradient-hero">
      <div className="container mx-auto flex items-center justify-between py-4 px-1">
        <img
          src="/images/logo2.png"
          alt="ONE Simulation"
          className="w-44 h-auto transition-opacity duration-300 hover:opacity-80 select-none"
          draggable="false"
        />

        <div className="flex items-center space-x-4">
          {!user ? (
            <>
              <Link to="/login">
                <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition">
                  Login
                </button>
              </Link>
              <Link to="/signup">
                <button className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition">
                  Signup
                </button>
              </Link>
            </>
          ) : (
            <NavbarNotifications />
          )}
        </div>
      </div>
    </div>
  );
};

function NavbarNotifications() {
  const { notifications, setNotifications } = useNotifications();
  const [open, setOpen] = useState(false);

  // Log whenever notifications array changes
  useEffect(() => {
    console.log('🔁 notifications updated in Navbar:', notifications);
  }, [notifications]);

  // Compute unread count
  const unreadCount = Array.isArray(notifications)
    ? notifications.filter((n) => !n.isRead).length
    : 0;

  return (
    <div className="relative">
      <button
        className="relative focus:outline-none"
        onClick={() => setOpen((o) => !o)}
        aria-label="Show notifications"
      >
        <FaBell className="text-2xl text-gray-700 hover:text-blue-600 transition" />
        {unreadCount > 0 && (
          <span className="absolute top-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white bg-red-500" />
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-80 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <div className="p-4 border-b font-semibold text-gray-700 flex items-center justify-between">
            Notifications
            {unreadCount > 0 && (
              <span className="bg-red-500 text-white text-xs rounded-full px-2 py-0.5">
                {unreadCount} new
              </span>
            )}
          </div>
          <div className="max-h-72 overflow-y-auto">
            <NotificationsList
              notifications={notifications}
              setNotifications={setNotifications}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar;
